import { Controller } from "@hotwired/stimulus"

const AUTOHIDE_DELAY = 8000

export default class extends Controller {
  connect() {
    this.timer = setTimeout(() => this.dismiss(), AUTOHIDE_DELAY)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.remove()
  }
}
